import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const ClipResultDropDown = ({
  userFilters,
  setUserFilters,
  showUserDropDown,
  onFiltersChange,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  showUserDropDown: boolean;
  onFiltersChange?: (updatedFilters: any) => void;
}) => {
  const sx = showUserDropDown ? { width: 120 } : { width: 130 };

  return (
    <div key="clip_result_dropdown">
      <Autocomplete
        value={userFilters.clip_result || ""}
        disablePortal
        options={["All", "Verified", "Unverified", "Faulted", "Unprocessed"]}
        onChange={(event, value: any) => {
          setUserFilters((previousState: any) => {
            return { ...previousState, clip_result: value || null };
          });
          if (onFiltersChange) {
            onFiltersChange({ ...userFilters, clip_result: value || null });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Clip Result"
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
